export const INDUSTRIES = [
  { value: "agency", label: "Agency", subs: [
    { value: "digital_marketing_agency", label: "Digital Marketing Agency" },
    { value: "creative_agency", label: "Creative / Design Agency" },
    { value: "pr_agency", label: "PR / Communications Agency" },
    { value: "media_buying_agency", label: "Media Buying Agency" },
    { value: "branding_agency", label: "Branding Agency" },
    { value: "agency_other", label: "Other Agency" },
  ]},
  { value: "saas", label: "SaaS", subs: [
    { value: "b2b_saas", label: "B2B SaaS" },
    { value: "b2c_saas", label: "B2C SaaS" },
    { value: "dev_tools", label: "Developer Tools" },
    { value: "martech", label: "Marketing Technology" },
    { value: "fintech", label: "FinTech" },
    { value: "saas_other", label: "Other SaaS" },
  ]},
  { value: "professional_services", label: "Professional Services", subs: [
    { value: "law_firm", label: "Law Firm / Legal Services" },
    { value: "accounting_firm", label: "Accounting / CPA Firm" },
    { value: "consulting_firm", label: "Management Consulting" },
    { value: "architecture_firm", label: "Architecture / Engineering" },
    { value: "staffing_recruiting", label: "Staffing / Recruiting" },
    { value: "it_services", label: "IT Services / MSP" },
    { value: "professional_services_other", label: "Other Professional Services" },
  ]},
  { value: "e-commerce", label: "E-Commerce", subs: [
    { value: "dtc_brand", label: "DTC / Direct-to-Consumer Brand" },
    { value: "marketplace", label: "Marketplace" },
    { value: "wholesale_distribution", label: "Wholesale / Distribution" },
    { value: "subscription_commerce", label: "Subscription Commerce" },
    { value: "ecommerce_other", label: "Other E-Commerce" },
  ]},
  { value: "real_estate", label: "Real Estate", subs: [
    { value: "residential_real_estate", label: "Residential Real Estate" },
    { value: "commercial_real_estate", label: "Commercial Real Estate" },
    { value: "property_management", label: "Property Management" },
    { value: "real_estate_investment", label: "Real Estate Investment" },
    { value: "real_estate_other", label: "Other Real Estate" },
  ]},
  { value: "healthcare", label: "Healthcare", subs: [
    { value: "medical_practice", label: "Medical Practice / Clinic" },
    { value: "dental_practice", label: "Dental Practice" },
    { value: "healthtech", label: "Health Tech / Digital Health" },
    { value: "home_health", label: "Home Health / Senior Care" },
    { value: "mental_health", label: "Mental Health / Therapy" },
    { value: "healthcare_other", label: "Other Healthcare" },
  ]},
  { value: "financial_services", label: "Financial Services", subs: [
    { value: "wealth_management", label: "Wealth Management / Advisory" },
    { value: "insurance", label: "Insurance" },
    { value: "mortgage_lending", label: "Mortgage / Lending" },
    { value: "investment_fund", label: "Investment Fund / EMD" },
    { value: "banking", label: "Banking / Credit Union" },
    { value: "financial_services_other", label: "Other Financial Services" },
  ]},
  { value: "media", label: "Media & Entertainment", subs: [
    { value: "content_production", label: "Content / Video Production" },
    { value: "publishing", label: "Publishing / Media" },
    { value: "events", label: "Events / Conference" },
    { value: "gaming", label: "Gaming" },
    { value: "media_other", label: "Other Media" },
  ]},
  { value: "education", label: "Education", subs: [
    { value: "edtech", label: "EdTech / Online Learning" },
    { value: "training_coaching", label: "Training / Coaching" },
    { value: "higher_education", label: "Higher Education" },
    { value: "k12", label: "K-12" },
    { value: "education_other", label: "Other Education" },
  ]},
  { value: "construction", label: "Construction & Trades", subs: [
    { value: "general_contractor", label: "General Contractor" },
    { value: "specialty_trade", label: "Specialty Trade (HVAC, Electrical, Plumbing)" },
    { value: "construction_other", label: "Other Construction" },
  ]},
  { value: "other", label: "Other", subs: [
    { value: "non_profit", label: "Non-Profit" },
    { value: "government", label: "Government" },
    { value: "manufacturing", label: "Manufacturing" },
    { value: "logistics", label: "Logistics / Transportation" },
    { value: "hospitality", label: "Hospitality / Food Service" },
    { value: "other_other", label: "Other" },
  ]},
];

export function getIndustryLabel(value) {
  for (const ind of INDUSTRIES) {
    if (ind.value === value) return ind.label;
    for (const sub of ind.subs) {
      if (sub.value === value) return sub.label;
    }
  }
  return (value || "").replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}

export function getIndustryParent(subValue) {
  for (const ind of INDUSTRIES) {
    for (const sub of ind.subs) {
      if (sub.value === subValue) return ind.label;
    }
  }
  return "";
}
